import { render, staticRenderFns } from "./ExhibitionPartnerList.vue?vue&type=template&id=6a209a82&scoped=true"
import script from "./ExhibitionPartnerList.vue?vue&type=script&lang=js"
export * from "./ExhibitionPartnerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a209a82",
  null
  
)

export default component.exports